import config from "@/config"
import http from "@/utils/request"

export default {
  activeConfig: {
    url: `${config.API_URL}/smsCode`,
    name: "验证码配置",
    get: async function (params = {}) {
      return await http.get(`${this.url}/activeconfig/list`, params)
    },
    submit: async function (data = {}) {
      return await http.post(`${this.url}/activeconfig/create`, data)
    },
    del: async function (data = {}) {
      return await http.post(`${this.url}/activeconfig/delete`, data)
    }
  },
  captchaLog: {
    url: `${config.API_URL}/smsCode`,
    name: "验证码日志",
    get: async function (params = {}) {
      return await http.get(`${this.url}/user/captchaLog/list`, params)
    },
    submit: async function (data = {}) {
      return await http.post(`${this.url}/activeconfig/create`, data)
    },
    del: async function (data = {}) {
      return await http.post(`${this.url}/activeconfig/delete`, data)
    }
  }
}
